import React from "react";
import Head from "next/head";
import { RequestNextApi } from "../../../api/Request";
import MarketingNavigation from "../../../navigation/marketing";
import { ChevronLeft } from "@mui/icons-material";
import { showArticleBlock } from "../../../utils/static-pages/function";
import { Typography } from "@mui/material";
import Link from "../../../src/Link";

export default function SingleBlogPage({ blog }) {
  // if (!blog) return <></>;
  const pageUrl = `https://kingdomeadvisors.com/industry-leader/news/${blog?.slug}`;
  const cleanDescription = (blog?.excerpt?.replace(/<[^>]*>/g, "") || "").slice(0, 100);
  const imageUrl = blog?.thumbnail?.url || "";
  const content = blog;
  return (
    <>
      <Head>
        {/* Basic Meta Tags */}
        <title>{blog?.title}</title>
        <meta name="description" content={cleanDescription} />
        <link rel="canonical" href={pageUrl} />
        
        {/* Open Graph / Facebook */}
        <meta property="og:title" content={blog?.title || ""} />
        <meta property="og:description" content={cleanDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="Kingdom Advisors" />
        <meta property="og:image" content={imageUrl} />
        <meta property="og:image:width" content={blog?.thumbnail?.width || '1200'} />
        <meta property="og:image:height" content={blog?.thumbnail?.height || '630'} />
        <meta property="og:image:alt" content={blog?.title || ""} />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blog?.title || ""} />
        <meta name="twitter:description" content={cleanDescription} />
        <meta name="twitter:image" content={imageUrl} />
      </Head>
      <MarketingNavigation>
        <div>
          <div className="max-w-7xl my-6 mx-auto px-2">
            <div className="flex items-center">
              <ChevronLeft
                onClick={() => window.history.back()}
                className="cursor-pointer"
              />
              <div className="flex items-center">
                <Typography className="text-sm font-normal ml-2">
                  <Link href="/">Home</Link> / <Link href="/industry-leader">Industry Leader</Link> / <Link href="/industry-leader/news">News</Link> / {blog?.title}
                </Typography>
              </div>
            </div>
          </div>
          {blog?.articleBlocks?.map((item, index) =>
            showArticleBlock(item, index, content)
          )}
        </div>
      </MarketingNavigation>
    </>
  );
}

export async function getServerSideProps(context) {
  const { id } = context.params;
  const slug = id;

  try {
    const res = await RequestNextApi.post("/blog/fetch-single", {
      slug,
    });

    const blog = res?.data?.success ? res?.data?.blog : res?.success ? res?.blog : null;

    if (!blog) {
      return {
        notFound: true,
      };
    }

    return {
      props: { blog },
    };
  } catch (error) {
    return {
      notFound: true,
    };
  }
}

SingleBlogPage.getLayout = (page) => <>{page}</>;
SingleBlogPage.isPublic = true;
